import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAllTattooImages, getTattooImageById } from '@/lib/api/tattoo';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 */
export const tattooQueries = {
  /**
   * Get all tattoo images for gallery
   */
  all: () =>
    queryOptions({
      queryKey: queryKeys.tattooImages.list(),
      queryFn: getAllTattooImages,
      staleTime: 1000 * 60 * 10, // 10 minutes
      retry: false,
    }),

  /**
   * Get tattoo image by ID
   */
  byId: (id: string) =>
    queryOptions({
      queryKey: queryKeys.tattooImages.detail(id),
      queryFn: () => getTattooImageById(id),
      staleTime: 1000 * 60 * 10,
      enabled: !!id,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch all tattoo images
 */
export const useGetAllTattooImages = () => useQuery(tattooQueries.all());

/**
 * Hook to fetch tattoo image by ID
 */
export const useGetTattooImageById = (id: string) => useQuery(tattooQueries.byId(id));
